/**
 * 학원 API 매장 스코프 헬퍼.
 *
 * master 만 현재 선택한 매장(session.store.id)을 API 에 명시적으로 전달한다.
 *   - GET  : query params 에 spread
 *   - POST/PATCH : request body 에 spread
 * manager/staff 는 빈 객체를 반환한다 — backend(resolveStoreId)가 본인 매장으로 강제하므로
 * 프론트가 storeId 를 보낼 필요가 없고, 보내도 무시된다(스코프 약화 아님).
 *
 * core 모듈(Dashboard/Members/Payments/AuditLogs)이 파일마다 인라인으로 쓰던
 *   role === 'master' ? { storeId: session.store.id } : {}
 * 규칙과 동일하며, 학원 화면 여러 곳에서 재사용하기 위해 하나로 뺐다.
 * (전역 axios interceptor 를 새로 만들지 않는다 — 요청 단위로 명시 전달)
 *
 * store 가 아직 선택되지 않았으면(store.id 없음) 빈 객체를 반환해 잘못된 호출을 만들지 않는다.
 */
export function academyScope(session) {
  return session?.user?.role === 'master' && session?.store?.id
    ? { storeId: session.store.id }
    : {};
}
